/* Verdant Lounge — scroll reveals + search polish. Fail-safe: without JS nothing hides. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduce) document.documentElement.classList.add('vl-motion');

  var SEL = [
    '.vl-sec-head', '.vl-usp__item', '.vl-steps__item', '.vl-faq__item',
    '.vl-contact__card', '.vl-tabs', '.collection-hero__inner',
    '.rich-text__wrapper', '.image-with-text__grid',
    '.collection-list .grid__item', '.collection .grid__item',
    '.product-grid .grid__item', '.footer-block'
  ].join(',');

  function watch() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('vl-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

    document.querySelectorAll(SEL).forEach(function (el, i) {
      if (el.dataset.vlRev) return;
      el.dataset.vlRev = '1';
      // stagger siblings within the same parent
      var sibs = el.parentElement ? [].indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--vl-d', Math.min(sibs, 7) * 55 + 'ms');
      // already on screen at load → show immediately, no flash
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.92 && r.bottom > 0) { el.classList.add('vl-in'); return; }
      io.observe(el);
    });
  }

  // safety net: if anything is still hidden after 2.5s, reveal it
  function safety() {
    setTimeout(function () {
      document.querySelectorAll('[data-vl-rev]:not(.vl-in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight) el.classList.add('vl-in');
      });
    }, 2500);
  }

  function init() { watch(); safety(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', watch);
})();
